import { ReactElement } from "react";
import './selectButton.css';

export interface SelectButtonProps {
    icon: ReactElement,
    options: Options[],
    selectedOption: string,
    onChange: Function,
    prefix?: string,
}

export interface Options {
    id: string,
    name: string,
}

export function SelectButton({ icon, options, selectedOption, onChange, prefix = '' } : SelectButtonProps) {

    return (
        <div className="select-button">
            {icon}
            <select name="select" value={selectedOption} onChange={(event) => onChange(event)}>
                {options.map((option) => <option key={option.id} value={option.id} >{prefix + option.name}</option>)}
            </select>
        </div>
    )
}